import {Button} from '@material-ui/core'
import Modal from 'modules/reports/components/Modal'
import ModalActions from 'modules/reports/components/Modal/Actions'
import ModalBody from 'modules/reports/components/Modal/Body'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsConfirmModal.styles'
import useModal from 'modules/reports/hooks/modal'

type Props = {
  message: React.ReactNode
  onConfirm: Function
  onCancel?: Function
}

function ReportsConfirmModal(props: Props) {
  const {message, onConfirm, onCancel} = props
  const classes = useStyles()
  const modal = useModal()
  const {p, pt} = useCore('reports', 'modals', 'Confirm')

  function handleConfirm() {
    modal.close()
    onConfirm()
  }

  function handleCancel() {
    modal.close()
    if (onCancel) onCancel()
  }

  return (
    <Modal data-testid={p()}>
      <ModalBody>
        <div className={classes.content} data-testid={p('content')}>
          {message}
        </div>

        <ModalActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            data-testid={p('confirm')}
          >
            {pt('confirm')}
          </Button>

          <Button onClick={handleCancel} data-testid={p('confirm')}>
            {pt('cancel')}
          </Button>
        </ModalActions>
      </ModalBody>
    </Modal>
  )
}

export default ReportsConfirmModal
